// 記事専用 Stimulus アプリ。
// 管理画面用の controllers/index（sidebar/chart 等）は読み込まず、
// 記事で使うコントローラーのみ登録して軽量に保つ（高速要件・jQuery非依存）。
// FAQ は native <details>/<summary> で実装するため Stimulus 不要。目次追従のみ Stimulus 化する。
import { Application } from '@hotwired/stimulus'
import TocController from '../controllers/toc_controller'
import ArticleChartController from '../controllers/article_chart_controller'

const application = Application.start()
application.register('toc', TocController)
application.register('article-chart', ArticleChartController)

export { application }
